(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-retail"] && !window.DesignMode) return;
  try {
    

let storeHours = window.store_hours;

const date = new Date();
const dayOfWeek = date.getDay();
const currentHour = date.getHours() * 100;

document.addEventListener('DOMContentLoaded', () => {
	const status = document.querySelector('[data-retail-status]');
  if (!status) return;
	const todaysHours = storeHours[dayOfWeek];

	if (currentHour >= todaysHours.openTime24) {
		if (currentHour >= todaysHours.closeTime24) {
			status.innerHTML = `
        <span>Closed</span> - opens tomorrow at ${todaysHours.openTime12}
      `;
		} else {
			status.innerHTML = `
        <span>Open</span> until ${todaysHours.closeTime12}
      `;
		}
	} else {
		status.innerHTML = `
      <span>Closed</span> - opens at ${todaysHours.openTime12}
    `;
	}
});


  } catch(e) { console.error(e); }
})();
})();
